import { Input } from 'antd'
import { useEffect, useState } from 'react'
import './CurrentInput.scss'

export const CurrentInput = ({ value, onChange }) => {
    const [inputValue, setInputValue] = useState('')
    const [backspace, setBackspace] = useState(false)
    const handleChange = e => {
        let result = e.target.value.replace(/[^0-9]/g, '').slice(0, 5)
        let result2 = result
        let hour = result.slice(0, 2)
        let mite = result.slice(2, 4)
        if (result.length > 2) {
            if (hour >= 24) hour = 24
            if (mite >= 59) mite = 59
            if (hour === 24 && !backspace) mite = '00'
            result2 = hour + ':' + mite
            return setInputValue(result2)
        }
        return setInputValue(result)
    }

    const handleKeyDown = e => {
        if (e.key === 'Backspace') {
            setBackspace(true)
        } else {
            setBackspace(false)
        }
    }

    useEffect(() => {
        setInputValue(value)
    }, [])

    useEffect(() => {
        onChange(inputValue)
    }, [inputValue])
    
    return (
        <Input
            className='currentInput keepRight'
            placeholder=''
            value={inputValue}
            onChange={handleChange}
            allowClear={false}
            onKeyDown={handleKeyDown}
        />
    )
}
